import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import Modal from '../../modal';
import { TerminateForm } from '../../forms';
import { Snackbar } from '../../snackbar';
import { getFullName } from '../../../utilities/string';
import { updateClientWorker } from '../../../reducers/clients';
import { dateToFloatingString } from '../../../utilities/dateTime';

class TerminateButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            job: undefined
        };

        // modal controls
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onOpen() {
        const { job } = this.props;
        this.setState({ modal: true, job: { ...job } });
    }

    onClose() {
        this.setState({ modal: false, job: undefined });
    }

    onSubmit(values) {
        const { updateClientWorker, handleTerminate, job } = this.props;
        const jobUpdate = {
            id: values.id,
            title: job.title,
            start_date: job.start_date,
            end_date: dateToFloatingString(values.end_date)
        };

        updateClientWorker(jobUpdate, () => {
            handleTerminate(job, () => {
                this.onClose();
                Snackbar.success(<FormattedMessage {...messages.assignmentTerminated} values={{ name: getFullName(job.user) }} />);
            });
        });
    }

    render() {
        const { modal, job } = this.state;
        const { button } = this.props;

        let buttonComponent = button ? (
            button
        ) : (
            <span className="button" onClick={this.onOpen}>
                {' '}
                <FormattedMessage {...messages.terminate} />
            </span>
        );

        return (
            <React.Fragment>
                {buttonComponent}
                <Modal
                    open={modal}
                    onClose={this.onClose}
                    managedClose
                    size="col-sm-8 col-sm-offset-2 col-xs-12 extend-modal"
                    title={<FormattedMessage {...messages.terminateAssignment} />}
                >
                    <TerminateForm job={job} onSubmit={this.onSubmit} cancel={this.onClose} initialValues={job} />
                </Modal>
            </React.Fragment>
        );
    }
}

TerminateButton.defaultProps = {
    button: undefined,
    onSuccess: () => {}
};
TerminateButton.propTypes = {
    button: PropTypes.any,
    onSuccess: PropTypes.func,
    handleTerminate: PropTypes.func.isRequired
};
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            updateClientWorker
        },
        dispatch
    );

export default connect(null, mapDispatchToProps)(TerminateButton);



// WEBPACK FOOTER //
// ./src/components/richButtons/terminateButton/index.jsx